/**
 * アプリ内ページパスの生成ヘルパー。
 *
 * ルート C′（静的 export）では dynamic route `/projects/[projectId]` を
 * 事前生成できないため、案件詳細はクエリパラメータ方式
 * `/projects/detail?projectId=...` に統一する。リンク生成は必ず本ヘルパーを
 * 使い、パス形式の知識を散在させない。
 */
export function projectDetailPath(
  projectId: string | number,
  extraParams?: Record<string, string>,
): string {
  const params = new URLSearchParams({ projectId: String(projectId) });
  for (const [key, value] of Object.entries(extraParams ?? {})) {
    if (value) params.set(key, value);
  }
  return `/projects/detail?${params.toString()}`;
}
